export interface ITranslations {
  signIn: string;
  settings: string;
  appearance: string;
  dark: string;
  light: string;
  language: string;
  es: string;
  fr: string;
  en: string;
  pt: string;
  search: string;
  voiceSearch: string;
  history: string;
  you: string;
  subscriptions: string;
  shorts: string;
  home: string;
  reportHistory: string;
  help: string;
  sendFeedback: string;
  moreFromYoutube: string;
  youtubePremium: string;
  youtubeMusic: string;
  youtubeKids: string;
  browseChannels: string;
  explore: string;
  trending: string;
  music: string;
  moviesTv: string;
  live: string;
  gaming: string;
  news: string;
  sport: string;
  learning: string;
  fashionBeauty: string;
  podcasts: string;
  signInMenuText: string;
  all: string;
  sports: string;
  boxing: string;
  gym: string;
  flowers: string;
  soccer: string;
  tennis: string;
  tesla: string;
  basketBall: string;
  housing: string;
  finance: string;
  stocks: string;
  technology: string;
  apple: string;
  fashion: string;
  showMore: string;
  showLess: string;
  save: string;
  saved: string;
  share: string;
  subscribe: string;
  subscribed: string;
  views: string;
  day: string;
  days: string;
  month: string;
  months: string;
  subscribers: string;
}
const es: ITranslations = {
  signIn: "Iniciar sesión",
  settings: "Configuración",
  appearance: "Apariencia",
  dark: "Oscuro",
  light: "Claro",
  language: "Idioma",
  es: "Español",
  fr: "Français",
  en: "English",
  pt: "Português",
  search: "Buscar en Pexels",
  voiceSearch: "Buscar con tu voz",
  history: "Historial",
  you: "Tú",
  subscriptions: "Suscripciones",
  shorts: "Shorts",
  home: "Inicio",
  reportHistory: "Historial de informes",
  help: "Ayuda",
  sendFeedback: "Enviar comentarios",
  moreFromYoutube: "Más de YouTube",
  youtubePremium: "YouTube Premium",
  youtubeMusic: "YouTube Música",
  youtubeKids: "YouTube Kids",
  browseChannels: "Explorar canales",
  explore: "Explorar",
  trending: "Tendencias",
  music: "Música",
  moviesTv: "Películas y TV",
  live: "En vivo",
  gaming: "Videojuegos",
  news: "Noticias",
  sport: "Deportes",
  learning: "Aprendizaje",
  fashionBeauty: "Moda y Belleza",
  podcasts: "Podcasts",
  signInMenuText: "Inicia sesión para dar me gusta a los videos y comentar.",
  all: "Todo",
  sports: "Deportes",
  boxing: "Boxeo",
  gym: "Gimnasio",
  flowers: "Flores",
  soccer: "Fútbol",
  tennis: "Tenis",
  tesla: "Tesla Inc",
  basketBall: "Baloncesto",
  housing: "Vivienda",
  finance: "Finanzas",
  stocks: "Acciones",
  technology: "Tecnología",
  apple: "Apple Inc",
  fashion: "Moda",
  showMore: "Mostrar más",
  showLess: "Mostrar menos",
  save: "Guardar",
  saved: "Guardado",
  share: "Compartir",
  subscribe: "Suscribirse",
  subscribed: "Suscrito",
  views: "Vistas",
  day: "Día",
  days: "Días",
  month: "Mes",
  months: "Meses",
  subscribers: "Suscriptores",
};

const fr: ITranslations = {
  signIn: "Se connecter",
  settings: "Paramètres",
  appearance: "Apparence",
  dark: "Sombre",
  light: "Clair",
  language: "Langue",
  es: "Español",
  fr: "Français",
  en: "English",
  pt: "Português",
  search: "Recherche dans Pexels",
  voiceSearch: "Recherche avec ta voix",
  history: "Histoire",
  you: "Toi",
  subscriptions: "Abonnements",
  shorts: "Shorts",
  home: "Maison",
  reportHistory: "Historique des rapports",
  help: "Aide",
  sendFeedback: "Envoyer des commentaires",
  moreFromYoutube: "Plus de Youtube",
  youtubePremium: "Youtube Premium",
  youtubeMusic: "Musique Youtube",
  youtubeKids: "Youtube Enfants",
  browseChannels: "Parcourir les chaînes",
  explore: "Explorer",
  trending: "Tendance",
  music: "Musique",
  moviesTv: "Films et télévision",
  live: "En direct",
  gaming: "Jeux",
  news: "Nouvelles",
  sport: "Sport",
  learning: "Apprentissage",
  fashionBeauty: "Fashion beauté",
  podcasts: "Baladodiffusions",
  signInMenuText: "Connectez-vous pour aimer les vidéos et commenter.",
  all: "All",
  sports: "Des sports",
  boxing: "Boxe",
  gym: "Salle de sport",
  flowers: "Fleurs",
  soccer: "Football",
  tennis: "Tennis",
  tesla: "Tesla Inc",
  basketBall: "Basket-ball",
  housing: "Logement",
  finance: "Finance",
  stocks: "Actions",
  technology: "Technologie",
  apple: "Apple Inc",
  fashion: "Mode",
  showMore: "Montre plus",
  showLess: "Montrer moins",
  save: "Sauvegarder",
  saved: "Sauvegardé",
  share: "Partager",
  subscribe: "S'abonner",
  subscribed: "Abonné",
  views: "Vues",
  day: "Jour",
  days: "Jours",
  month: "Mois",
  months: "Mois",
  subscribers: "Abonnés",
};

const en: ITranslations = {
  signIn: "Sign in",
  settings: "Settings",
  appearance: "Appearance",
  dark: "Dark",
  light: "Light",
  language: "Language",
  es: "Español",
  fr: "Français",
  en: "English",
  pt: "Português",
  search: "Search in Pexels",
  voiceSearch: "Search with your voice",
  history: "History",
  you: "You",
  subscriptions: "Subscriptions",
  shorts: "Shorts",
  home: "Home",
  reportHistory: "Report History",
  help: "Help",
  sendFeedback: "Send Feedback",
  moreFromYoutube: "More from Youtube",
  youtubePremium: "Youtube Premium",
  youtubeMusic: "Youtube Music",
  youtubeKids: "Youtube Kids",
  browseChannels: "Browse Channels",
  explore: "Explore",
  trending: "Trending",
  music: "Music",
  moviesTv: "Movies & Tv",
  live: "Live",
  gaming: "Gaming",
  news: "News",
  sport: "Sport",
  learning: "Learning",
  fashionBeauty: "Fashion Beauty",
  podcasts: "Podcasts",
  signInMenuText: "Sign in to like videos, comment and subscribe.",
  all: "All",
  sports: "Sports",
  boxing: "Boxing",
  gym: "Gym",
  flowers: "Flowers",
  soccer: "Soccer",
  tennis: "Tennis",
  tesla: "Tesla Inc",
  basketBall: "Basket Ball",
  housing: "Housing",
  finance: "Finance",
  stocks: "Stocks",
  technology: "Technology",
  apple: "Apple Inc",
  fashion: "Fashion",
  showMore: "Show more",
  showLess: "Show less",
  save: "Save",
  saved: "Saved",
  share: "Share",
  subscribe: "Subscribe",
  subscribed: "Subscribed",
  views: "Views",
  day: "Day",
  days: "Days",
  month: "Month",
  months: "Months",
  subscribers: "Subscribers",
};

const pt: ITranslations = {
  signIn: "Entrar",
  settings: "Configurações",
  appearance: "Aparência",
  dark: "Escuro",
  light: "Claro",
  language: "Idioma",
  es: "Español",
  fr: "Français",
  en: "English",
  pt: "Português",
  search: "Pesquisar no Pexels",
  voiceSearch: "Pesquisar com sua voz",
  history: "Histórico",
  you: "Você",
  subscriptions: "Inscrições",
  shorts: "Shorts",
  home: "Início",
  reportHistory: "Histórico de denúncias",
  help: "Ajuda",
  sendFeedback: "Enviar feedback",
  moreFromYoutube: "Mais do YouTube",
  youtubePremium: "YouTube Premium",
  youtubeMusic: "YouTube Music",
  youtubeKids: "YouTube Kids",
  browseChannels: "Explorar canais",
  explore: "Explorar",
  trending: "Em alta",
  music: "Música",
  moviesTv: "Filmes e TV",
  live: "Ao vivo",
  gaming: "Jogos",
  news: "Notícias",
  sport: "Esportes",
  learning: "Aprendizado",
  fashionBeauty: "Moda e Beleza",
  podcasts: "Podcasts",
  signInMenuText: "Entre para curtir vídeos, comentar e se inscrever.",
  all: "Tudo",
  sports: "Esportes",
  boxing: "Boxe",
  gym: "Academia",
  flowers: "Flores",
  soccer: "Futebol",
  tennis: "Tênis",
  tesla: "Tesla Inc",
  basketBall: "Basquete",
  housing: "Habitação",
  finance: "Finanças",
  stocks: "Ações",
  technology: "Tecnologia",
  apple: "Apple Inc",
  fashion: "Moda",
  showMore: "Mostrar mais",
  showLess: "Mostrar menos",
  save: "Salvar",
  saved: "Salvo",
  share: "Compartilhar",
  subscribe: "Inscrever-se",
  subscribed: "Inscrito",
  views: "Visualizações",
  day: "Dia",
  days: "Dias",
  month: "Mês",
  months: "Meses",
  subscribers: "Inscritos",
};

export const LANGUAGE = {
  es,
  fr,
  en,
  pt,
};
